import { FormattedMessage } from 'react-intl';
import React from 'react';

export const getRefreshLabel = (lastUpdated) => {
  return (
    <FormattedMessage
      id="hosting.sync_status.synced_text"
      defaultMessage="Synced {time}"
      values={{
        time: lastUpdated
      }}
    />
  );
};

const LastUpdatedStrings = {
  refreshButton: <FormattedMessage id="calendar.connect_cta.button_refresh" defaultMessage="Refresh"/>
};

export default LastUpdatedStrings;
